"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._CallbackStacker = void 0;
const types_1 = require("./types");
function filterByFilters(cb, node) {
    return (0, types_1.asMany)(cb.filters).every(f => f(node));
}
function execCallbacks(callbacks, node, enableExecutedCallbacks) {
    for (let cb of callbacks) {
        cb.callback(node);
        if (enableExecutedCallbacks)
            node.executedCallbacks.push(cb);
    }
}
function execCallbacksAsync(callbacks, node, enableExecutedCallbacks) {
    return __awaiter(this, void 0, void 0, function* () {
        for (let cb of callbacks) {
            yield cb.callback(node);
            if (enableExecutedCallbacks)
                node.executedCallbacks.push(cb);
        }
    });
}
const execCallbacksAsyncInParallel = (callbacks, node) => __awaiter(void 0, void 0, void 0, function* () {
    yield Promise.all(callbacks.map(cb => Promise.resolve(cb.callback(node))
        .then(() => {
        node.executedCallbacks.push(cb);
    })));
});
class _CallbackStacker {
    constructor(ctx, executor) {
        this.ctx = ctx;
        this.executor = executor;
        this.lookup = {};
    }
    static forSync(ctx) {
        return new _CallbackStacker(ctx, execCallbacks);
    }
    static forAsync(ctx) {
        return new _CallbackStacker(ctx, ctx.config.parallelizeAsyncCallbacks
            ? execCallbacksAsyncInParallel
            : execCallbacksAsync);
    }
    _matchCallbacks(node, position) {
        let callbacks = this.ctx.callbacksByPosition[position];
        return (callbacks || [])
            .map(cb => cb)
            .filter(cb => filterByFilters(cb, node));
    }
    pushToStack(node, position) {
        const lastChild = node.children[node.children.length - 1];
        const callbacks = this._matchCallbacks(node, position);
        this.lookup[lastChild.id] = {
            trigger: node.id,
            fn: () => this.executor(callbacks, node, this.ctx.config.trackExecutedCallbacks)
        };
    }
    executeOne(node, position) {
        const callbacks = this._matchCallbacks(node, position);
        return this.executor(callbacks, node, this.ctx.config.trackExecutedCallbacks);
    }
    *execute(nodeId) {
        let next = this.lookup[nodeId];
        delete this.lookup[nodeId];
        while (next) {
            yield next.fn();
            const trigger = next.trigger;
            next = this.lookup[trigger];
            delete this.lookup[trigger];
        }
    }
}
exports._CallbackStacker = _CallbackStacker;
